import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/views/Login.vue'
import Signin from '@/views/Signin.vue'
import NeoAi from '@/views/NeoAi.vue'
import utils from '@/utils/utils'
const proto = Vue.prototype
import storage from '@/utils/storage'
import strings from './strings'

Vue.use(Router)

const router = new Router({
  base: 'organization',
  mode: 'history',
  routes: [
    {
      path: '/clients',
      name: 'Clients',
      component: () => import('@/views/admin/Clients.vue'),
      meta: {
        globalAdminUrlOnly: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: Signin,
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/user/settingsInitial',
      name: 'UserSettingsInitial',
      component: () => import('./views/UserSettings'),
      meta: {
        hideMenuOptions: true,
        fullScreen: true,
        features: {
          hasBookingFeatures: true
        }
      }
    },
    {
      path: '/user/settings',
      name: 'UserSettings',
      component: () => import('./views/UserSettings'),
      meta: {
        features: {
          hasBookingFeatures: true
        }
      }
    },
    {
      path: '/user/bookings',
      name: 'UserBookings',
      component: () => import('./views/UserBookings'),
      meta: {
        features: {
          hasBookingFeatures: true
        }
      }
    },
    {
      path: '/neoai',
      name: 'NeoAi',
      component: NeoAi,
      meta: {
        enabledForGlobalAdminHostName: true,
        featureFlag: strings.featureFlags.neoAi,
        features: {
          hasBookingFeatures: true
        }
      }
    },
    {
      path: '/guest/bookings',
      name: 'UserBookings',
      component: () => import('./views/UserBookings'),
      meta: {
        hasBookingForGuests: true,
        features: {
          hasBookingFeatures: true
        }
      }
    },
    {
      path: '/admin/settings/interface/color',
      name: 'ColorSettings',
      component: () => import('@/views/admin/ColorSettings'),
      meta: {
        roles:{
          client: true,
          settings: true
        }
      }
    },
    {
      path: '/admin/settings/*',
      name: 'Settings',
      component: () => import('@/views/admin/Settings'),
      meta: {
        roles:{
          client: true,
          settings: true
        }
      }
    },
    {
      path: '/admin/restrictions',
      name: 'Restrictions',
      component: () => import('@/views/admin/Restrictions'),
      meta: {
        features: {
          hasBookingForDesk: true,
        },
        roles:{
          client: true,
          settings: true,
          site: true
        }
      }
    },
    {
      path: '/admin/restrictions/create',
      name: 'ManageRestrictions',
      component: () => import('@/views/admin/ManageRestrictions'),
      meta: {
        features: {
          hasBookingForDesk: true,
        },
        roles:{
          client: true,
          settings: true,
          site: true
        }
      }
    },
    {
      path: '/admin/restrictions/edit/:id',
      name: 'ManageRestrictions',
      component: () => import('@/views/admin/ManageRestrictions'),
      meta: {
        features: {
          hasBookingForDesk: true,
        },
        roles:{
          client: true,
          settings: true,
          site: true
        }
      }
    },
    {
      path: '/admin/reports/restrictions',
      name: 'Restrictions',
      component: () => import('@/views/admin/RestrictionReport'),
      meta: {
        features: {
          hasBookingForDesk: true,
        },
        roles:{
          client: true,
          settings: true,
          site: true
        }
      }
    },
    {
      path: '/admin/reports/unbookedEntrance',
      name: 'UnbookedEntranceReport',
      component: () => import('@/views/admin/UnbookedEntranceReport'),
      meta: {
        features: {
          hasBookingFeatures: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/settings/site/:id',
      name: 'SiteSettings',
      component: () => import('@/views/admin/SiteSettings'),
      meta: {
        roles:{
          client: true,
          site: true,
          settings: true
        }
      }
    },
    {
      path: '/admin/administrators/global',
      name: 'Administrators',
      component: () => import ('@/views/admin/Administrators'),
      meta: {
        roles:{
          client: true
        }
      }
    },
    {
      path: '/admin/administrators/site',
      name: 'Administrators',
      component: () => import ('@/views/admin/Administrators'),
      meta: {
        roles:{
          client: true
        }
      }
    },
    {
      path: '/admin/global/tvs',
      name: 'Tvs',
      component: () => import('@/views/admin/Tvs'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/tv',
      name: 'ManageTv',
      component: () => import('@/views/admin/ManageTv'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/tv/:id',
      name: 'ManageTv',
      component: () => import('@/views/admin/ManageTv'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/tablets',
      name: 'Tablets',
      component: () => import('@/views/admin/Tablets'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/camera',
      name: 'ManageCamera',
      component: () => import('@/views/admin/ManageCamera'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/camera/:id',
      name: 'ManageCamera',
      component: () => import('@/views/admin/ManageCamera'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/cameras',
      name: 'Cameras',
      component: () => import('@/views/admin/Cameras'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/comfortpack',
      name: 'ComfortPack',
      component: () => import('@/views/admin/ComfortPack'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/spaces2check',
      name: 'Space2Check',
      component: () => import('@/views/admin/Space2Check'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/space2check',
      name: 'ManageSpace2Check',
      component: () => import('@/views/admin/ManageSpace2Check'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/space2check/:id',
      name: 'ManageSpace2Check',
      component: () => import('@/views/admin/ManageSpace2Check'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/featureflags',
      name: 'FeatureFlags',
      component: () => import('@/views/admin/FeatureFlags'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/application/settings',
      name: 'ApplicationSettings',
      component: () => import('@/views/admin/ApplicationSettings'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/tablet',
      name: 'ManageTablet',
      component: () => import('@/views/admin/ManageTablet'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/tablet/:id',
      name: 'ManageTablet',
      component: () => import('@/views/admin/ManageTablet'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/features',
      name: 'Features',
      component: () => import('@/views/admin/Features'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/sites',
      name: 'Sites',
      component: () => import('@/views/admin/Sites'),
      meta: {
        features: {
          hasBookingFeatures: true
        },
        roles:{
          site: {
            edit: false
          },
          client: {
            edit: false
          },
          settings: {
            edit: false
          }
        }
      }
    },
    {
      path: '/admin/locations',
      name: 'Locations',
      component: () => import('@/views/admin/Locations'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/global/featureflag',
      name: 'ManageFeatureFlags',
      component: () => import('@/views/admin/ManageFeatureFlags'),
      meta: {
        globalAdminUrlOnly: true,
        roles: {
          client: true
        }
      }
    },
    {
      path: '/admin/global/featureflag/:id',
      name: 'ManageFeatureFlags',
      component: () => import('@/views/admin/ManageFeatureFlags'),
      meta: {
        globalAdminUrlOnly: true,
        roles: {
          client: true
        }
      }
    },
    {
      path: '/admin/location/:locationId/wayfinding/map',
      name: 'ManageWayfinding',
      component: () => import('@/views/admin/ManageWayfinding'),
      meta: {
        globalAdminUrlOnly: true,
        features: {
          hasWayfinding: true
        },
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/location/:locationId/map',
      name: 'ManageMap',
      component: () => import('@/views/admin/ManageMap'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/location/:locationId/integration',
      name: 'ManageLocationIntegration',
      component: () => import('@/views/admin/ManageLocationIntegration'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/groups/notification',
      name: 'NotificationGroups',
      component: () => import('@/views/admin/NotificationGroups'),
      meta: {
        roles:{
          client: true,
          group: true
        }
      }
    },
    {
      path: '/admin/groups/employees',
      name: 'EmployeeGroups',
      component: () => import('@/views/admin/EmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/create/deskGroups',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/create/rooms',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/create/charteredBuses',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/create/parkings',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/create/lockers',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/edit/:id/deskGroups',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/edit/:id/rooms',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/edit/:id/charteredBuses',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/edit/:id/parkings',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/edit/:id/lockers',
      name: 'ManageEmployeeGroups',
      component: () => import('@/views/admin/ManageEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/admin/groups/employees/users/:id',
      name: 'UsersEmployeeGroups',
      component: () => import('@/views/admin/UsersEmployeeGroups'),
      meta: {
        roles:{
          client: true,
          group: true,
          upload: true
        }
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('./views/Contact')
    },
    {
      path: '/document',
      name: 'Document',
      component: () => import('./views/Document')
    },
    {
      path: '/admin/contact',
      name: 'ManageContact',
      component: () => import('./views/admin/ManageContact'),
      meta: {
        roles:{
          client: true
        }
      }
    },
    {
      path: '/admin/dashboards/devices',
      name: 'DashboardDevices',
      component: () => import('@/views/admin/DashboardDevices'),
      meta: {
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/dashboards/sensors',
      name: 'DashboardSensors',
      component: () => import('@/views/admin/DashboardSensors'),
      meta: {
        roles:{
          client: true,
          site: true
        }
      }
    },
    {
      path: '/admin/alerts',
      name: 'ComfortAlerts',
      component: () => import('@/views/admin/ComfortAlerts'),
      meta: {
        roles:{
          client: true,
          site: true
        }
      }
    },
    {
      path: '/team',
      name: 'MyTeam',
      component: () => import('@/views/MyTeam'),
      meta: {
        features: {
          hasBookingForDesk: true
        }
      }
    },
    {
      path: '/team/invite',
      name: 'TeamInvite',
      component: () => import('@/views/TeamInvite'),
      meta: {
        features: {
          hasBookingForDesk: true
        }
      }
    },
    {
      path: '/admin/dashboards/occupancy',
      name: 'DashboardOccupancy',
      component: () => import('@/views/admin/DashboardOccupancy'),
      meta: {
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/users',
      name: 'Users',
      component: () => import('@/views/admin/Users'),
      meta: {
        roles: {
          client: true
        }
      }
    },
    {
      path: '/access-control/areas',
      name: 'AccessControlAreas',
      component: () => import('@/views/admin/AccessControlAreas'),
      meta: {
        hasAccessControl: true,
        featureFlag: strings.featureFlags.neoAccess,
        roles: {
          client: true
        }
      }
    },
    {
      path: '/access-control/area/:areaId/behavior',
      name: 'AccessControlAreaBehavior',
      component: () => import('@/views/admin/AccessControlAreaBehavior'),
      meta: {
        hasAccessControl: true,
        featureFlag: strings.featureFlags.neoAccess,
        roles: {
          client: true
        }
      }
    },
    {
      path: '/access-control/accesses',
      name: 'AccessControlAccesses',
      component: () => import('@/views/admin/AccessControlAccesses'),
      meta: {
        hasAccessControl: true,
        featureFlag: strings.featureFlags.neoAccess,
        roles: {
          client: true
        }
      }
    },
    {
      path: '/*',
      name: 'Error',
      component: () => import('@/views/Error'),
      meta: {
        hideLoading : true
      }
    }
  ]
})

const getClientAdminFromSession = () => {
  let obj = {
    clientIdDesk4Me: storage.getFromLocalStorage('clientIdDesk4Me'),
    clientIdFreeroom: storage.getFromLocalStorage('clientIdFreeroom'),
    originalDesk4MeId: storage.getFromLocalStorage('originalDesk4MeId'),
    originalFreeroomId: storage.getFromLocalStorage('originalFreeroomId')
  }
  store.dispatch('Client/setClientAdmin', obj, {root: true})
}

const checkAdminUrlFeaturesAndNavigate = async (to, from, next) => {
  if (store.getters['Auth/isGlobalAdminHostname']) {
    getClientAdminFromSession()
    if (!to.meta.globalAdminUrlOnly &&
        !to.meta.disableAuth &&
        store.getters['Client/originalDesk4MeId'] &&
        store.getters['Client/originalFreeroomId'] &&
        to.path !== '/notFound' &&
        to.path !== '/') {
      next({path: '/'})
    }
  } else if (!store.getters['Auth/isGlobalAdminHostname']) {
    if (to.meta.globalAdminUrlOnly) {
      next({path: '/notFound'})
    }
  }
  //check features to allow router
  if(utils.checkFeatureInRoute(to.meta.features, store.getters['Global/hasProduct'])){
    next()
  } else {
    next({path: '/notFound'})
  }
}

const checkFeatureFlag = (to) => {
  let isAllowed = true
  if (store.getters['Auth/isGlobalAdminHostname'] && to.meta.enabledForGlobalAdminHostName) {
    return isAllowed
  }
  if (to.meta.featureFlag) {
    const featureFlags = store.getters['Global/featureFlags']
    const foundFeatureFlag = featureFlags.find(item => item.name === to.meta.featureFlag)

    isAllowed = foundFeatureFlag ? foundFeatureFlag.active : false
  }
  return isAllowed
}

const checkAdminRole = (to) => {
  let isAllowed = false
  if(to.meta.roles){
      for(var roleInRoute in to.meta.roles){
        let available = (store.getters['Auth/role'] && store.getters['Auth/role'].some( role => role === proto.$rolesOrganization.rolesWithoutGroup[roleInRoute])) || store.getters['Auth/isGlobalAdmin']
        if(available){
          isAllowed = true
        }
      }
  }
  return isAllowed
}

const isRoleAllowed = (to) => {
  if (!checkFeatureFlag(to)) {
    return false
  }
  if (to.meta.hasAccessControl && !store.getters['Global/hasAccessControl']) {
    return false
  }
  if(checkAdminRole(to)){
    return true
  }
  if (to.meta.hasBookingForGuests) {
    const siteHasBookingForGuests = getSiteConfigsHasBookingForGuests()
    return ((store.getters['Global/hasBookingForGuests'] || siteHasBookingForGuests))
  }
  if (to.meta.globalAdminUrlOnly) {
    if (store.getters['Auth/isGlobalAdmin']) {
      return true
    } else {
      return false
    }
  }
  if (to.path.includes('admin')) {
    return false
  }
  return true
}

const checkRole = async (to, from, next) => {
  if (isRoleAllowed(to, from, next)) {
    checkAdminUrlFeaturesAndNavigate(to, from, next)
  } else {
    next('/notFound')
  }
}

const checkLoading = (to) => {
  if (to.meta.hideLoading) {
    store.dispatch('Global/hideLoading', null, {root: true})
  }
}

const getSiteConfigsHasBookingForGuests = () => {
  const siteConfigs = store.getters['Global/initialSettingsSiteConfigs']
  return siteConfigs.some(x => x.hasBookingForGuests === true)
}

router.beforeEach(async (to, from, next) => {
  if (store.getters['Auth/isAuthenticated']) {
    // already signed in, we can navigate anywhere
    await checkRole(to, from, next)
    checkLoading(to)
  } else if (!to.meta.disableAuth) {
    // authentication is required. Trigger the sign in process
    await store.dispatch('Auth/authenticate')
    if(store.getters['Auth/isAuthenticated']){
      await checkRole(to, from, next)
      checkLoading(to)
    } else {
      next({path: '/login'})
    }
  } else {
    // No auth required. We can navigate
    await checkRole(to, from, next)
    checkLoading(to)
  }
})
// eslint-disable-next-line no-unused-vars
router.afterEach(async (to, from) => {
  window.gtag('config', process.env.VUE_APP_GT_TAG, {
    'page_title': to.name,
    'page_path': to.path
  })
  window.cx.tracking('send', 'screen', to.name)
})



export default router
